
export async function sendData(userId , point) {
  try {
    const response = await fetch("https://api.filetrust.io/api/user/presale", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userId,
        point: point,
      }),
    });
  } catch (t) {
    console.error("Error during communication:", t);
  }
}